export function kebabCase( str ){
    return str
        .replace(/([a-z])([A-Z])/g, '$1-$2')    // get all lowercase letters that are near to uppercase ones
        .replace(/[\s_]+/g, '-')                // replace all spaces and low dash
        .replace(/[&/\\#,+()$~%.'":*?<>{}]/g, '')                // remove remaining special characters
        .toLowerCase()                          // convert to lower case
}

export function isEmpty( obj ){
    return Object.keys(obj).length === 0;
}

export function slugify( string ){
    
    const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
    const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
    const p = new RegExp(a.split('').join('|'), 'g')

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w-]+/g, '') // Remove all non-word characters
        .replace(/--+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export function arrayRemove( arr, value, key ){
    return arr.filter( element => ( key ? element[ key ] : element ) != value )
} 


export function ensureHTTP( str ){
    return /^https?:\/\//.test( str ) && str || `http://${str}`
}

export function stringContains( str, test ){
    return str.indexOf( test ) !== -1;
}

export function simplify( str ){
    return str.toLowerCase().replace( " ", "" )
}